



























































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Mutation, State, Getter, Action } from 'vuex-class';
import { Watch } from 'vue-property-decorator';

import { IPayment, IPaymentable } from '../../models';
import { BaseDetail } from '../Base/BaseDetail';
import { lowercase } from '@/utils';

const namespace = 'payment';
const ns = { namespace };

@Component
export default class PaymentDetail extends BaseDetail<IPayment> {
  namespace = namespace;
  @State('entities', ns) entities: Record<string, IPayment>;
  @Action('createEntity', ns) createEntity: any;
  @Action('getEntity', ns) getEntity: any;
  @Action('updateEntity', ns) updateEntity: any;
  @Action('deleteEntity', ns) deleteEntity: any;

  paymentTypes: Record<string, IPaymentable> = {};
  paymentTypesEnum = [
    {
      name: 'Входящий',
      value: 'incoming',
    },
    {
      name: 'Исходящий',
      value: 'outgoing',
    },
  ];
  paymentItems: object[] = [];
  async mounted() {
    await this.loadEntity();
    const { data } = await this.client.get<IPaymentable[]>('payment/available');
    this.paymentTypes = data.reduce((acc, item) => {
      acc[item.value] = item;
      return acc;
    }, {} as Record<string, IPaymentable>);
    if (this.entity.paymentable_type)
      this.client
        //@ts-ignore
        .get(this.paymentTypes[this.entity.paymentable_type].url)
        .then(({ data }) => {
          this.paymentItems = data;
        });
  }
  get createView() {
    return Boolean(this.entityId);
  }
  get paymentableTitle() {
    if (!this.entity.paymentable_type) return '';
    if (Object.keys(this.paymentTypes).length > 0) {
      const paymentableName = this.paymentTypes[this.entity.paymentable_type]
        .name;
      return `Выберите ${lowercase(paymentableName)}`;
    } else return '';
  }
  @Watch('entity.paymentable_type', { immediate: true, deep: true })
  async getPaymentableItems() {
    if (
      !this.entity.paymentable_type ||
      !this.paymentTypes[this.entity.paymentable_type]
    ) {
      return;
    }
    this.client
      .get(this.paymentTypes[this.entity.paymentable_type].url)
      .then(({ data }) => {
        this.paymentItems = data;
      });
  }
}
